<template>
  <div :class="['documentsBox', isMobile ? 'mobileMargin':'PCMargin']"
  >
    <!-- 移动端  -->
    <div v-if="isMobile">
      <DocumentMobile></DocumentMobile>
    </div>
    <!-- PC端   -->
    <div v-else class="menu-navBox">
      <el-menu
          class="menu-nav"
          background-color="#282828"
          text-color="#81818C"
          active-text-color="#fff"
          :default-active="$route.path"
          unique-opened
          router>
        <menu-item :list="documentData"></menu-item>
      </el-menu>

      <div class="menu-content" >
        <div class="padding20">
          <!-- <el-breadcrumb class="breadcrumb" separator=">">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>标准文档</el-breadcrumb-item>
            <el-breadcrumb-item>{{activeMenuName}}</el-breadcrumb-item>
          </el-breadcrumb> -->
          <div class="documentsContent">
            <!-- <router-view class="page-box"></router-view> -->
            <document class="page-box" v-if="isRouterAlive"></document>
          </div>
          <ICP bgcClor="#fafafa" color="#bdc2c7"></ICP>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ICP from "@/components/ICP";
import document from "@/components/documents/document";
import DocumentMobile from "@/components/documents/document-mobile";
import menuItem from "@/components/documents/menuItem";
import { singleDocumentsSever } from "@/common/api-config";
export default {
  components: {
    ICP,document,menuItem,DocumentMobile
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  created() {
    // 判断当前是否移动端
    this.isMobile = utils.isMobile()
    console.log(this.isMobile);
    this.queryMenuList();
  },
  mounted(){
  },
  computed: {
    getRedirectMap() {
      return this.$store.getters['documentStore/getRedirectMap'];
    },
    hasRequestMap() {
      return this.$store.getters['documentStore/getStatus'];
    },
  },
  watch: {
    '$route.params.id' :{
      async handler(to,from) {
        console.log(this.getRedirectMap,to);
        // 判断是否需要重定向
        if (!this.hasRequestMap) await this.$store.dispatch('documentStore/queryRedirectMap')
        if (this.getRedirectMap[to]) {
          console.log(this.getRedirectMap[to]);
          this.$router.replace(`/documents/${from}`)
          window.location.href = this.getRedirectMap[to]
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      isRouterAlive: true,
      id:'',
      documentData: [],
      activeRouter: '',
      activeMenuName:'',
      isMobile: false // 是否移动端
    };
  },  
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    queryMenuList() {
      singleDocumentsSever.queryMenuList().then(res => {
        if (res.code == 0) {
          this.documentData = res.data;
          if(!this.$route.params.id && this.documentData.length ){
            this.recursionId(this.documentData)
            setTimeout(()=>{
              this.$router.push({
                path:'/documents/'+this.id,
              })
            },30)
          }
        }
      });
    },
    recursionId(list=[]) {
      for (var i = 0; i < list.length; i++) {
        if(list[i].id ){
          if(this.id==''){
            this.id=list[i].id
          }
          break;
        }else{
            this.recursionId(list[i].children)
        }
      };
    },
  }

};
</script>

<style scoped lang="scss">
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

/deep/ .el-scrollbar__view {
  height: 100%;
}
.documentsBox {
  height: calc(100% - 64px); //减头高度
  &.mobileMargin {
    //margin-top: 10vw;
  }
  &.PCMargin {
    margin-top: 64px;
  }
  .menu-navBox {
    display: flex;
    height: 100%;
    .menu-nav {
      width: 250px;
      padding: 20px 0;
      min-height: calc(100% - 64px); //减头高度
      .menu-navItem {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 40px!important;
        height: 70px;
        line-height: 70px;
        font-size: 18px;
        .el-icon-arrow-right{
          margin-top: -2px;
        }
      }
      .is-active {
        color: #fff !important;
      }
    }
    .menu-content {
      width: 100%;
      flex: 1;
      background: #fafafa;
      min-width: 0;
      .padding20{
        height: 100%;
        padding: 0px 20px ;
        .documentsContent{
          padding: 20px 10px;
          height: calc(100% - 60px); //减头高度
          .page-box{
            height: 100%;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 800px) {
    .documentsBox {
      margin-top: 20px !important;
      .menu-nav{
        display: none;
      }
      .documentsContent{
        padding: 20px!important;
         /deep/ img{
          width: 100%;
         }
      }
    }
}
</style>

